import { Container } from "./styled";

const InputCustom = (props) => {
    return (
        <Container>
            {props.children}
        </Container>
    )
}

export default InputCustom
